import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import Newsletter from "../components/Newsletter";
import ServiceInnerDetails from "../components/ServiceInnerDetails";

const ServiceEquipes = () => {
  let [active, setActive] = useState(true);
  useEffect(() => { setTimeout(function () { setActive(false); }, 500); }, []);
  return (
    <>
      <HelmetReact title={"Estruturação de Equipes"} />
      <HeaderTwo />
      <Breadcrumb title="Estruturação de Equipes" />
      <ServiceInnerDetails serviceId="equipes" />
      <FooterTwo />
    </>
  );
};
export default ServiceEquipes;